(function(){
  var counters = document.querySelectorAll('[data-zlp-count]');
  if (!counters.length) return;
  var seen = new WeakSet();
  function animate(el){
    var target = parseInt(el.getAttribute('data-zlp-count'), 10);
    var start = null;
    var DURATION = 1200;
    function tick(ts){
      if (!start) start = ts;
      var p = Math.min((ts - start) / DURATION, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + '%';
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting && !seen.has(e.target)) {
          seen.add(e.target);
          animate(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    counters.forEach(function(c){ io.observe(c); });
  } else {
    counters.forEach(animate);
  }
})();